export default "/_assets/download.0f99166c.svg"